module.exports = __webpack_public_path__ + "static/media/h3.618eb53b.svg";